import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'Home',
                    icon: 'fas fa-home',
                },
                acl: {
                    view: 'PU_00001',
                },
            },
            settings: {
                menu: {
                    route: `${code}.settings`,
                    text: `settings.titles`,
                    icon: 'fas fa-cogs',
                },
                acl: {
                    view                    : 'PU_00021',
                    edit                    : 'PU_00022',
                },
                url: {
                    getConfig               : `/${codeAPI}/gestao/definitions`,
                },
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: 'default_layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'PU_00115',
                    detail                  : 'PU_00116',
                    add                     : 'PU_00117',
                    edit                    : 'PU_00118',
                    delete                  : 'PU_00119',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/defaultlayers`,
                    getShow                 : `${codeAPI}/gestao/defaultlayers/:id`,
                    getCreate               : `${codeAPI}/gestao/defaultlayers`,
                    getUpdate               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getDelete               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getLists                : `${codeAPI}/gestao/defaultlayers/lists`,
                    getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            layers: {
                menu: {
                    route: `${code}.layers`,
                    text: `layers.titles`,
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'PU_00017',
                    detail                  : 'PU_00016',
                    add                     : 'PU_00014',
                    edit                    : 'PU_00015',
                    delete                  : 'PU_00018',
                    private                 : 'PU_00003',
                },
                url: {
                    getList: `${codeAPI}/gestao/layers`,
                    getShow: `${codeAPI}/gestao/layers/:id`,
                    getCreate: `${codeAPI}/gestao/layers`,
                    getUpdate: `${codeAPI}/gestao/layers/:id`,
                    getDelete: `${codeAPI}/gestao/layers/:id`,
                    getLists: `${codeAPI}/gestao/layers/lists`,
                    getResources: `${codeAPI}/gestao/layers/resources`,
                    describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                },
            },
            regulations: {
                menu: {
                    route: `${code}.regulations`,
                    text: `regulations.titles`,
                    icon: 'fas fa-book',
                },
                acl: {
                    view                    : 'PU_00026',
                    detail                  : 'PU_00025',
                    add                     : 'PU_00023',
                    edit                    : 'PU_00024',
                    delete                  : 'PU_00027',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/regulations`,
                    getShow                 : `${codeAPI}/gestao/regulations/:id`,
                    getCreate               : `${codeAPI}/gestao/regulations`,
                    getUpdate               : `${codeAPI}/gestao/regulations/:id`,
                    getDelete               : `${codeAPI}/gestao/regulations/:id`,
                    getLists                : `${codeAPI}/gestao/regulations/lists`,
                },
            },
            print_visible_emissions: {
                menu: {
                    route: `${code}.print_visible_emissions.config`,
                    text: `print_visible_emissions.titles`,
                    icon: 'fas fa-print',
                },
                acl: {
                    view                    : 'PU_00019',
                    config                  : 'PU_00019',
                    configEdit              : 'PU_00020',
                },
                url: {
                    getList                 : `/${codeAPI}/gestao/printvisible`,

                    getConfig               : `/${codeAPI}/gestao/printvisible/settings`,
                    getApps                 : `/${codeAPI}/gestao/printvisible/print/apps`,
                },
            },
            equipment_types: {
                menu: {
                    route: `${code}.equipment_types`,
                    text: `equipment_types.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00037',
                    detail                  : 'PU_00036',
                    add                     : 'PU_00034',
                    edit                    : 'PU_00035',
                    delete                  : 'PU_00038',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/equipmenttypes`,
                    getShow                 : `${codeAPI}/gestao/equipmenttypes/:id`,
                    getCreate               : `${codeAPI}/gestao/equipmenttypes`,
                    getUpdate               : `${codeAPI}/gestao/equipmenttypes/:id`,
                    getDelete               : `${codeAPI}/gestao/equipmenttypes/:id`,
                },
            },
            green_space_types: {
                menu: {
                    route: `${code}.green_space_types`,
                    text: `green_space_types.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00042',
                    detail                  : 'PU_00041',
                    add                     : 'PU_00039',
                    edit                    : 'PU_00040',
                    delete                  : 'PU_00043',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/greenspacetypes`,
                    getShow                 : `${codeAPI}/gestao/greenspacetypes/:id`,
                    getCreate               : `${codeAPI}/gestao/greenspacetypes`,
                    getUpdate               : `${codeAPI}/gestao/greenspacetypes/:id`,
                    getDelete               : `${codeAPI}/gestao/greenspacetypes/:id`,
                },
            },
            license_file_types: {
                menu: {
                    route: `${code}.license_file_types`,
                    text: `license_file_types.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00047',
                    detail                  : 'PU_00046',
                    add                     : 'PU_00044',
                    edit                    : 'PU_00045',
                    delete                  : 'PU_00048',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/licensefiletypes`,
                    getShow                 : `${codeAPI}/gestao/licensefiletypes/:id`,
                    getCreate               : `${codeAPI}/gestao/licensefiletypes`,
                    getUpdate               : `${codeAPI}/gestao/licensefiletypes/:id`,
                    getDelete               : `${codeAPI}/gestao/licensefiletypes/:id`,
                },
            },
            license_statuses: {
                menu: {
                    route: `${code}.license_statuses`,
                    text: `license_statuses.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00062',
                    detail                  : 'PU_00061',
                    add                     : 'PU_00059',
                    edit                    : 'PU_00060',
                    delete                  : 'PU_00063',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/licensestatuses`,
                    getShow                 : `${codeAPI}/gestao/licensestatuses/:id`,
                    getCreate               : `${codeAPI}/gestao/licensestatuses`,
                    getUpdate               : `${codeAPI}/gestao/licensestatuses/:id`,
                    getDelete               : `${codeAPI}/gestao/licensestatuses/:id`,
                },
            },
            license_types: {
                menu: {
                    route: `${code}.license_types`,
                    text: `license_types.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00067',
                    detail                  : 'PU_00066',
                    add                     : 'PU_00064',
                    edit                    : 'PU_00065',
                    delete                  : 'PU_00068',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/licensetypes`,
                    getShow                 : `${codeAPI}/gestao/licensetypes/:id`,
                    getCreate               : `${codeAPI}/gestao/licensetypes`,
                    getUpdate               : `${codeAPI}/gestao/licensetypes/:id`,
                    getDelete               : `${codeAPI}/gestao/licensetypes/:id`,
                },
            },
            license_use_types: {
                menu: {
                    route: `${code}.license_use_types`,
                    text: `license_use_types.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00072',
                    detail                  : 'PU_00071',
                    add                     : 'PU_00069',
                    edit                    : 'PU_00070',
                    delete                  : 'PU_00073',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/licenseusetypes`,
                    getShow                 : `${codeAPI}/gestao/licenseusetypes/:id`,
                    getCreate               : `${codeAPI}/gestao/licenseusetypes`,
                    getUpdate               : `${codeAPI}/gestao/licenseusetypes/:id`,
                    getDelete               : `${codeAPI}/gestao/licenseusetypes/:id`,
                },
            },
            lot_use_types: {
                menu: {
                    route: `${code}.lot_use_types`,
                    text: `lot_use_types.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00032',
                    detail                  : 'PU_00031',
                    add                     : 'PU_00029',
                    edit                    : 'PU_00030',
                    delete                  : 'PU_00033',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/lotusetypes`,
                    getShow                 : `${codeAPI}/gestao/lotusetypes/:id`,
                    getCreate               : `${codeAPI}/gestao/lotusetypes`,
                    getUpdate               : `${codeAPI}/gestao/lotusetypes/:id`,
                    getDelete               : `${codeAPI}/gestao/lotusetypes/:id`,
                },
            },
            places: {
                menu: {
                    route: `${code}.places`,
                    text: `places.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00077',
                    detail                  : 'PU_00076',
                    add                     : 'PU_00074',
                    edit                    : 'PU_00075',
                    delete                  : 'PU_00078',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/places`,
                    getShow                 : `${codeAPI}/gestao/places/:id`,
                    getCreate               : `${codeAPI}/gestao/places`,
                    getUpdate               : `${codeAPI}/gestao/places/:id`,
                    getDelete               : `${codeAPI}/gestao/places/:id`,
                },
            },
            license_owners: {
                menu: {
                    route: `${code}.license_owners`,
                    text: `license_owners.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00052',
                    detail                  : 'PU_00051',
                    add                     : 'PU_00049',
                    edit                    : 'PU_00050',
                    delete                  : 'PU_00053',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/licenseowners`,
                    getShow                 : `${codeAPI}/gestao/licenseowners/:id`,
                    getCreate               : `${codeAPI}/gestao/licenseowners`,
                    getUpdate               : `${codeAPI}/gestao/licenseowners/:id`,
                    getDelete               : `${codeAPI}/gestao/licenseowners/:id`,
                },
            },
            license_guarantee_owners: {
                menu: {
                    route: `${code}.license_guarantee_owners`,
                    text: `license_guarantee_owners.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00057',
                    detail                  : 'PU_00056',
                    add                     : 'PU_00054',
                    edit                    : 'PU_00055',
                    delete                  : 'PU_00058',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/licenseguaranteeowners`,
                    getShow                 : `${codeAPI}/gestao/licenseguaranteeowners/:id`,
                    getCreate               : `${codeAPI}/gestao/licenseguaranteeowners`,
                    getUpdate               : `${codeAPI}/gestao/licenseguaranteeowners/:id`,
                    getDelete               : `${codeAPI}/gestao/licenseguaranteeowners/:id`,
                },
            },
            license_guarantee_types: {
                menu: {
                    route: `${code}.license_guarantee_types`,
                    text: `license_guarantee_types.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00090',
                    detail                  : 'PU_00091',
                    add                     : 'PU_00092',
                    edit                    : 'PU_00093',
                    delete                  : 'PU_00094',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/licenseguaranteetypes`,
                    getShow                 : `${codeAPI}/gestao/licenseguaranteetypes/:id`,
                    getCreate               : `${codeAPI}/gestao/licenseguaranteetypes`,
                    getUpdate               : `${codeAPI}/gestao/licenseguaranteetypes/:id`,
                    getDelete               : `${codeAPI}/gestao/licenseguaranteetypes/:id`,
                },
            },
            license_guarantee_states: {
                menu: {
                    route: `${code}.license_guarantee_states`,
                    text: `license_guarantee_states.titles`,
                    icon: 'fas fa-keyboard',
                },
                acl: {
                    view                    : 'PU_00095',
                    detail                  : 'PU_00096',
                    add                     : 'PU_00097',
                    edit                    : 'PU_00098',
                    delete                  : 'PU_00099',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/licenseguaranteestates`,
                    getShow                 : `${codeAPI}/gestao/licenseguaranteestates/:id`,
                    getCreate               : `${codeAPI}/gestao/licenseguaranteestates`,
                    getUpdate               : `${codeAPI}/gestao/licenseguaranteestates/:id`,
                    getDelete               : `${codeAPI}/gestao/licenseguaranteestates/:id`,
                },
            },
        },
        tools: {

        },
    },
};

export default state;
